import script from "./Payment.vue?vue&type=script&setup=true&lang=ts"
export * from "./Payment.vue?vue&type=script&setup=true&lang=ts"

import "./Payment.vue?vue&type=style&index=0&id=7ed4c0af&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ed4c0af"]])

export default __exports__